import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

function formatDate(dt) {
  try {
    const d = new Date(dt);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString();
  } catch {
    return "";
  }
}

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    async function load() {
      setLoading(true);
      setErr("");

      try {
        const { data } = await api.get("admin/users?limit=200");
        if (!data?.ok) throw new Error(data?.message || "Failed to load users");
        if (alive) setUsers(Array.isArray(data.rows) ? data.rows : []);
      } catch (e) {
        if (alive) setErr(e?.message || "Failed to load users");
        if (alive) setUsers([]);
      } finally {
        if (alive) setLoading(false);
      }
    }

    load();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section style={panel}>
      <h2 style={{ margin: 0 }}>Users</h2>

      {loading ? <p style={muted}>Loading...</p> : null}
      {!loading && err ? <p style={{ ...muted, color: "crimson" }}>{err}</p> : null}

      {!loading && !err && users.length === 0 ? <p style={muted}>No users found.</p> : null}

      {!loading && !err && users.length > 0 ? (
        <div style={{ overflowX: "auto", marginTop: 14 }}>
          <table style={table}>
            <thead>
              <tr>
                <th style={th}>ID</th>
                <th style={th}>Username</th>
                <th style={th}>Email</th>
                <th style={th}>Role</th>
                <th style={th}>Created</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td style={td}>{u.id}</td>
                  <td style={td}>{u.name || ""}</td>
                  <td style={td}>{u.email || ""}</td>
                  <td style={td}>{u.role || ""}</td>
                  <td style={td}>{formatDate(u.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </section>
  );
}

const panel = {
  background: "#fff",
  border: "1px solid #eee",
  borderRadius: 18,
  padding: 18,
  minHeight: 200,
};

const muted = { opacity: 0.75, marginTop: 10 };

const table = { width: "100%", borderCollapse: "collapse" };

const th = {
  textAlign: "left",
  padding: "10px 8px",
  borderBottom: "1px solid #eee",
  fontWeight: 700,
  whiteSpace: "nowrap",
};

const td = {
  padding: "10px 8px",
  borderBottom: "1px solid #f2f2f2",
  verticalAlign: "top",
  whiteSpace: "nowrap",
};
